import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AgrPrintPageModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Location } from '@next/core-lib/user';

import { CowWithMeasurement } from 'src/app/height-measurement/models/cow.model';
import { AlvaMetricsDto } from 'src/app/insemination-advice/models/alva-metrics.model';
import { InseminationPrintRow } from 'src/app/insemination-advice/models/insemination-advice.model';

export interface SelectedDateWithColor {
  date: Date;
  color: string;
}

@Component({
  selector: 'company-report-print',
  templateUrl: './company-report-print.component.html',
  styleUrls: ['./company-report-print.component.scss'],
  standalone: true,
  imports: [CommonModule, AgrPrintPageModule, AgrI18nSharedModule],
})
export class CompanyReportPrintComponent {
  @Input() chartImageUrl: string | null = null;
  @Input() printTableData: InseminationPrintRow[] = [];
  @Input() reportDate: Date | null = null;
  @Input() alvaMetrics: AlvaMetricsDto | null = null;
  @Input() selectedDates: SelectedDateWithColor[] = [];
  @Input() location: Location | null = null;
  @Input() stallListCowMeasurements: CowWithMeasurement[] = [];
  @Input() stallListDate: Date | null = null;

  showLogo = true;

  onLogoError(): void {
    this.showLogo = false;
  }

  printTableDataFn(): InseminationPrintRow[] {
    return this.printTableData ?? [];
  }

  reportDateFn(): Date {
    return this.reportDate ?? new Date();
  }
}
